import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import Bar from "./components/Bar";

import {black500} from "assets/jss/main";
import {UserAgentUtils} from "../../utils/useragent";

function ProgressBarList({items = [], height = 12, rowGap = 12}) {
    const isMobile = UserAgentUtils.isMobile();

    return (
        <div style={{display: "grid", gridTemplateColumns: "auto 1fr auto", columnGap: "12px", rowGap, alignItems: "center"}}>
            {items.map(({label, percentage, valueLabel, color}, index) => (
                <Fragment key={index}>
                    <span style={{
                        fontSize: isMobile ? '12px' : "14px",
                        color: "#6b7280",
                        textAlign: isMobile ? 'left' : "right",
                        whiteSpace: "nowrap",
                        alignSelf: "center",
                        width: '100px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}>
                        {label}
                    </span>
                    <Bar percentage={percentage} height={height} color={color}/>
                    <span style={{
                        fontSize: isMobile ? '12px' : "14px",
                        fontWeight: 600,
                        color: black500,
                        whiteSpace: "nowrap",
                        alignSelf: "center",
                        ...isMobile && {
                            textAlign: 'right'
                        }
                    }}>
                        {valueLabel}
                    </span>
                </Fragment>
            ))}
        </div>
    );
}

ProgressBarList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        percentage: PropTypes.number.isRequired,
        valueLabel: PropTypes.string,
        color: PropTypes.string,
    })).isRequired,
    height: PropTypes.number,
    rowGap: PropTypes.number,
};

export default ProgressBarList;
